var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-text-page',{attrs:{"field":"privacyPolicy","title":"Privacy Policy"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v("Shown at lavishlocations.com/privacypolicy.")]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d471631","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/site-content/PrivacyPolicy.vue
// module id = 588
// module chunks = 0